import React, { Component } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setLiabilityGrouping } from '../../../actions/liabilities'
import { AssetGroups } from '../../../constants/assetGroups'

function mapStateToProps(state) {
  return {
    liabilityGroup: state.liabilityInfo.liabilityGroup || AssetGroups.TYPE
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setLiabilityGrouping: liabilityGroup => dispatch(setLiabilityGrouping(liabilityGroup))
  }
}

class LiabilityGroupingSelector extends Component {
  toSentenceCase(str) {
    return str.toString().split("_").map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
  }

  toGroupValue(label) {
    return AssetGroups[label.split(" ").map(w => w.toUpperCase()).join("_")];
  }

  render() {
    return (
      <Form as={Row} className="align-items-center g-2">
        <Col xs="auto">
          <Form.Label className="mb-0">Group by</Form.Label>
        </Col>
        <Col xs="auto">
          <Form.Select
            name="liabilityGroupingSelector"
            value={this.toSentenceCase(this.props.liabilityGroup)}
            onChange={e => this.props.setLiabilityGrouping(this.toGroupValue(e.target.value))}
          >
            {Object.keys(AssetGroups).map(g => <option key={g}>{this.toSentenceCase(g)}</option>)}
          </Form.Select>
        </Col>
      </Form>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LiabilityGroupingSelector);
